import { render, staticRenderFns } from "./WebPartnerList.vue?vue&type=template&id=37482c05&scoped=true"
import script from "./WebPartnerList.vue?vue&type=script&lang=js"
export * from "./WebPartnerList.vue?vue&type=script&lang=js"
import style0 from "./WebPartnerList.vue?vue&type=style&index=0&id=37482c05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37482c05",
  null
  
)

export default component.exports